import lexiconJson from "../../../data/orders-lexicon.json";
import {
  isRecord,
  validationFailure,
  validationSuccess,
  type ValidationResult,
} from "../../../data/validation";

export interface LexiconEntry {
  readonly spoken: string;
  readonly written: string;
}

export interface OrdersLexicon {
  readonly schemaVersion: 1;
  readonly entries: readonly LexiconEntry[];
  readonly equipmentDesignators: readonly string[];
  readonly unresolvedTokens: readonly string[];
}

function stringArray(value: unknown): value is readonly string[] {
  return (
    Array.isArray(value) && value.every((entry) => typeof entry === "string")
  );
}

export function validateOrdersLexicon(
  value: unknown,
  source: string,
): ValidationResult<OrdersLexicon> {
  if (!isRecord(value)) {
    return validationFailure(source, "$", "expected a JSON object");
  }
  if (value.schemaVersion !== 1) {
    return validationFailure(
      source,
      "$.schemaVersion",
      "expected schemaVersion 1",
    );
  }
  if (!Array.isArray(value.entries)) {
    return validationFailure(source, "$.entries", "expected an array");
  }
  for (const [index, entry] of value.entries.entries()) {
    if (
      !isRecord(entry) ||
      typeof entry.written !== "string" ||
      typeof entry.spoken !== "string"
    ) {
      return validationFailure(
        source,
        `$.entries[${String(index)}]`,
        "expected written and spoken strings",
      );
    }
  }
  if (!stringArray(value.unresolvedTokens)) {
    return validationFailure(
      source,
      "$.unresolvedTokens",
      "expected a string array",
    );
  }
  if (!stringArray(value.equipmentDesignators)) {
    return validationFailure(
      source,
      "$.equipmentDesignators",
      "expected a string array",
    );
  }
  return validationSuccess(value as unknown as OrdersLexicon);
}

const validation = validateOrdersLexicon(
  lexiconJson,
  "app/data/orders-lexicon.json",
);

/* v8 ignore next -- the imported, committed JSON is validated in unit tests */
if (!validation.ok) throw new Error(validation.error.message);

export const ordersLexicon: OrdersLexicon = Object.freeze(validation.value);
